<template>

	<div class="flex flex-col h-full">
		<div v-if="pedido" class="block h-full overflow-y-scroll">
			<div class="flex-auto overflow-scroll w-full"> 
				<div class="flex justify-between pt-4 px-4 items-top">
					<div class="flex-none">
						<p class="text-2xl font-bold">
							Remisión #{{pedido.id}}
						</p>
						<p class="text-xl">
							{{pedido.created_at ? (new Date(pedido.created_at)).toLocaleDateString("en-GB", { timeZone: 'America/Mexico_City' }) : ""}}
						</p>
						<p class="text-xl">
							{{pedido.cliente ? pedido.cliente.nombre : ""}}
						</p>
					</div>

					<div class="text-left" style="height: 88px; width: 88px">
						<qr :text="enlace" size=100 color="#000000" bg-color="#ffffff" error-level="L"></qr>
					</div>
				</div>				

				<div class="border boder-gray-300 rounded mt-4 mb-4 mx-4">
					<div v-if="pedido.datos_entrega && pedido.datos_entrega.direccion" class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-b-gray-200">
								<tr>
									<th scope="col" class="py-3 px-6 w-4/12">
										Dirección de entrega
									</th>													
								</tr>
							</thead>
							<tbody class="">
								<tr class="text-s">
									<th v-if="pedido && pedido.datos_entrega" scope="row" class="py-3 px-6 font-medium whitespace-nowrap">
										<p>{{pedido.datos_entrega.direccion.calle}} {{pedido.datos_entrega.direccion.exterior}}</p>						
										<p>{{pedido.datos_entrega.direccion.colonia}} {{pedido.datos_entrega.direccion.codigo}}</p>						
										<p>{{pedido.datos_entrega.direccion.estado}}</p>
									</th>														
								</tr>              
							</tbody>
						</table>
					</div>

					<div v-if="Object.values(horario).some(dia => dia && dia.start)" class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-t border-b-gray-200">
								<tr>
									<th scope="col" class="py-3 px-6 w-3/12">
										Horario
									</th>												
								</tr>
							</thead>
							<tbody class="">
								<tr class="text-s">
									<th scope="row" class="py-3 px-6 font-medium whitespace-nowrap">
										<div v-for="day in Object.keys(horario)" v-bind:key="day">
											<p v-if="horario[day] && horario[day].start">
												{{day}} de {{horario[day].start}} a {{horario[day].end}}
											</p>
										</div>
									</th>														
								</tr>              
							</tbody>
						</table>
					</div>

					<div v-if="pedido.instrucciones"  class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-t border-b-gray-200">
								<tr>
									<th scope="col" class="py-3 px-6 w-4/12">
										Instrucciones
									</th>													
								</tr>
							</thead>
							<tbody class="">
								<tr class="text-s">
									<th scope="row" class="py-3 px-6 font-medium whitespace-nowrap">
										{{pedido.instrucciones}}
									</th>														
								</tr>              
							</tbody>
						</table>
					</div>

					<div class="overflow-scroll">
						<table class="w-full text-sm text-left ">
							<thead class="text-s border-b border-t border-b-gray-200 border-t-gray-200">
								<tr>
									<th scope="col" class="py-3 px-6 w-4/12">
										Nombre
									</th>
									<th scope="col" class="py-3 px-6 w-4/12">
										Proveedor
									</th>
									<th scope="col" class="py-3 px-6 w-4/12">
										Cantidad
									</th>							
								</tr>
							</thead>
							<tbody>
								<tr class="text-s border-b border-b-gray-200" v-for="line_item in pedido.line_items" v-bind:key="line_item.id">				
									<td class="py-3 px-6 whitespace-nowrap ">
										<div class="flex items-center">
											<div v-if="line_item.producto.foto" class="rounded overflow-hidden w-20 mr-4">
												<img :src="line_item.producto.foto" class="">
											</div>
											{{line_item.producto.nombre}}
										</div>
									</td>
									<td class="py-3 px-6 font-medium whitespace-nowrap">
										{{pedido.proveedor ? pedido.proveedor.nombre : ""}}
									</td>
									<td class="py-3 px-6">
										{{line_item.cantidad}}
									</td>							
								</tr>              
							</tbody>
							<tfoot class="text-s text-gray-700 dark:text-gray-400 ">									
								<tr>
									<th scope="col" class="py-3 px-6 w-4/12">
										Total
									</th>
									<th scope="col" class="py-3 px-6 w-4/12">
									</th>
									<th v-if="pedido.id" scope="col" class="py-3 px-6 w-4/12">
										{{pedido.line_items.map( l => {return (l.cantidad)} ).reduce((a, b) => a + b, 0) }}
									</th>							
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qr from 'vue-qr-generator'
	import { utils } from "./utils/utils.js"
	import { store } from "../store.js"
	import { useRoute } from "vue-router"	
	import { computed, ref, watch } from "vue"
	import { useLoading } from 'vue-loading-overlay'
	import { useToast } from 'vue-toast-notification'
	
	export default {
		name: 'Order',
		components: {
			qr: qr
		},
		setup() {			
			const route = useRoute()
			const pedido = ref(null)
			const loading = useLoading({ color: '#428b74', loader: 'spinner' })
			const admin = computed(() => route.name === 'Admin_Remision')

			watch(
				() => [route.params.orden_id, route.params.proveedor_id, admin.value, store.authReady && (admin.value ? store.authAdmin : store.auth)],
				async ([pedidoId, proveedorId, isAdmin, authorized], previous, onCleanup) => {
					let active = true
					let loader
					onCleanup(() => {
						active = false
						loader?.hide()
						loader = null
					})
					pedido.value = null
					if (!authorized) return

					loader = loading.show()
					try {
						const data = await utils.getPedidoConRecoleccion(pedidoId, isAdmin ? null : proveedorId)
						if (active) pedido.value = data
					} catch (error) {
						if (!active) return
						if (error.status === 401) {
							if (isAdmin) store.setAuthAdmin(false)
							else store.setAuth(false)
						} else {
							useToast().error(error.message || 'No se pudo cargar la remisión', { position: 'top-right' })
						}
					} finally {
						loader?.hide()
						loader = null
					}
				},
				{ immediate: true }
			)

			const enlace = computed( () => {        
				return pedido.value?.id ? `https://www.pickpack.mx/cliente/${pedido.value.cliente.id}/orden/${pedido.value.id}` : ""
			})

			const horario = computed( () => {
				const horarioEntrega = pedido.value?.datos_entrega?.horario

				if (horarioEntrega && Object.values(horarioEntrega).some(dia => dia && dia.start)) {
					return horarioEntrega
				}
				return pedido.value?.cliente?.horario || {}
			})

			return {      
				pedido,
				enlace,
				horario
			}
		},
	}
</script>
